import { createInstance } from '@/helpers/api/base'
import { useAppQuery } from '@/helpers/api/query'

export const useGetConfirmDetails = () => {
    return useAppQuery<IConfirmDetailsResponse>({
        queryKey: ['confirm-details'],
        queryFn: () =>
            createInstance({
                url: '/confirm-details',
                method: 'GET',
            }),
    })
}
